import { z } from "zod/v4";
import { checkProveedor } from "../api/check-proveedor";
import { useEffect } from "react";
import useFetch from "@/hooks/use-fetch";
import { Alert, CircularProgress, Collapse } from "@mui/material";
import { DataCache } from "@/components/display";
import { Form, FormProps } from "@/components/form";

export const addProveedorFormSchema = z.object({
    numDocumento: z.string().nonempty("Este campo es requerido"),
    nombre: z.string().nonempty("Este campo es requerido"),
    email: z.email(),
    telefono: z.string(),
    direccion: z.string()
})

export default function AddProveedorForm({
    form,
    ...props
}: FormProps<z.infer<typeof addProveedorFormSchema>>) {
    const { fetch, value, loading, error } = useFetch(async (value: string) => {
        if (value) return await checkProveedor(value);
        return undefined;
    }, { debounceMs: 500 });

    const shouldDisable = value === undefined || loading || Boolean(error);

    useEffect(() => {
        if (shouldDisable || !value) {
            form.setFieldValue("nombre", "");
            form.setFieldValue("email", "");
            form.setFieldValue("telefono", "");
            form.setFieldValue("direccion", "");
        } else {
            form.setFieldValue("nombre", value.nombre);
            form.setFieldValue("email", value.email);
            form.setFieldValue("telefono", value.telefono);
            form.setFieldValue("direccion", value.direccion);
        }
    }, [value, loading, error])

    return <Form form={form} gap={3} {...props}>
        <Collapse in={!loading && value !== undefined} sx={{ marginY: "-10px" }}>
            <DataCache data={value}>
                {value => <Alert severity="info">
                    {value == null ? "Se agregara una nueva persona" : "Se editara una persona existente"}
                </Alert>}
            </DataCache>
        </Collapse>
        <Form.TextField name="numDocumento" label="N° Documento" onChange={e => fetch(e.target.value)}
            slotProps={{ input: { endAdornment: loading && <CircularProgress size={20} /> } }} />
        <Form.TextField name="nombre" label="Nombre" disabled={shouldDisable} />
        <Form.TextField name="email" label="Email" disabled={shouldDisable} />
        <Form.TextField name="telefono" label="Telefono" disabled={shouldDisable} />
        <Form.TextField name="direccion" label="Dirección" disabled={shouldDisable} />
        <Form.SubmitButton disabled={shouldDisable}>Guardar</Form.SubmitButton>
    </Form>
}